import { init as initApm } from "@elastic/apm-rum";
import {
  ELASTIC_SERVER_URL,
  ELASTIC_APM_ACTIVE,
  REACT_APP_VERSION,
  API_URL,
} from "../constants";

const initializeElasticApm = () => {
  return initApm({
    // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
    serviceName: "fr-data-cleaning-webapp",

    // Set custom APM Server URL (default: http://localhost:8200)
    serverUrl: ELASTIC_SERVER_URL,

    // Set the service version (required for source map feature)
    serviceVersion: REACT_APP_VERSION,

    // Set the service environment
    environment: process.env.NODE_ENV,

    active: ELASTIC_APM_ACTIVE,

    distributedTracingOrigins: [API_URL],
  });
};

const useApm = () => {
  return window.elasticApm;
};

export { initializeElasticApm };
export default useApm;
